export interface NotificationBannerMessage {
  id?: number;
  message?: string;
  enabled?: boolean;
  action?: {
    link?: string;
    text?: string;
  };
  visibility?: NotificationBannerVisibilityStatus;
}

/**
 * Three state "boolean" that indicates the visibility of a notification banner message.
 * undefined/0 - all users can see the message
 * 1 - only logged in users can see the message
 * 2 - only logged out users can see the message
 */
export enum NotificationBannerVisibilityStatus {
  ALL_USERS,
  LOGGED_IN_ONLY,
  LOGGED_OUT_ONLY,
}

export const NOTIFICATION_BANNER_MESSAGE_LOCAL_STORAGE_KEY = 'notificationMessages';
